import Register from "../register/Register";
import FormContent from "./FormContent";
import { ForgotPasswordPopup } from "../forgot-password/ForgotPasswordPopup";

const LoginPopup = () => {
  return (
    <>
      <div className="modal fade" id="loginPopupModal">
        <div className="modal-dialog modal-lg modal-dialog-centered login-modal modal-dialog-scrollable">
          <div
            className="modal-content"
            style={{
              backgroundColor: "transparent",
              border: 0,
              borderRadius: 0,
            }}
          >
            <button
            type="button"
            className="closed-modal"
            data-bs-dismiss="modal"
            style={{ position: "absolute", top: "10px", right: "10px", transform: "translateX(-10px)" }}
          ></button>

            {/* End close modal btn */}

            <div className="modal-body">
              {/* <!-- Login modal --> */}
              <div id="login-modal">
                {/* <!-- Login Form --> */}
                <div className="login-form default-form">
                  <FormContent />
                </div>
                {/* <!--End Login Form --> */}
              </div>
              {/* <!-- End Login Module --> */}
            </div>
            {/* En modal-body */}
          </div>
          {/* End modal-content */}
        </div>
      </div>
      {/* <!-- Login Popup Modal --> */}

      <div className="modal fade" id="registerModal">
        <div className="modal-dialog modal-lg modal-dialog-centered login-modal modal-dialog-scrollable">
          <div
            className="modal-content"
            style={{
              backgroundColor: "transparent",
              border: 0,
              borderRadius: 0,
            }}
          >
            <button
              type="button"
              className="closed-modal"
              data-bs-dismiss="modal"
               style={{ position: "absolute", top: "10px", right: "10px", transform: "translateX(-10px)" }}
            ></button>
            {/* End close modal btn */}

            <div className="modal-body">
              {/* <!-- Login modal --> */}
              <div id="login-modal">
                {/* <!-- Login Form --> */}
                <div className="login-form default-form">
                  <Register />
                </div>
                {/* <!--End Login Form --> */}
              </div>
              {/* <!-- End Login Module --> */}
            </div>
            {/* En modal-body */}
          </div>
          {/* End modal-content */}
        </div>
      </div>
      {/* <!-- Login Popup Modal --> */}

      <ForgotPasswordPopup show={false} onHide={() => {}} />
    </>
  );
};

export default LoginPopup;
